import { styled } from '@material-ui/core';

export const ShareCont = styled('div')(({ theme }) => ({
  padding: 20,
  minWidth: 500,
  [theme.breakpoints.down('sm')]: {
    minWidth: 'unset',
  },
}));

export const ShareButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 10,
  gap: 10,
}));
